import { Typography } from 'antd';
import { LayersOutlinedIcon } from '../icons';
import { MessageSources } from './MessageSources';
import { useAntTheme } from '../../hooks/useAntTheme';
import { useTranslation } from 'react-i18next';
import {
  type MediaProjectInstanceResponse,
  type MessageOrigin,
} from '../../types';
import { ProcessingLabel } from './components/ProcessingLabel';

type SourcesProps = {
  sources?: MessageOrigin[];
  isProcessing: boolean;
  displaySource: (source: MessageOrigin) => void;
  mainDocumentId?: string;
  publicationDocuments?: MediaProjectInstanceResponse['documents'];
};

export const Sources = ({
  sources,
  isProcessing,
  displaySource,
  mainDocumentId,
  publicationDocuments,
}: SourcesProps) => {
  const { theme } = useAntTheme();
  const { t } = useTranslation('translation', { useSuspense: false });
  const hasSources = !!sources?.length;
  return (
    <div>
      {/* When PROCESSING SOURCES otherwise show sources */}
      {isProcessing && (
        <ProcessingLabel
          icon={
            <LayersOutlinedIcon
              stroke={theme.colorText}
              width={18}
              height={18}
              style={{ position: 'relative', top: 1, left: 3 }}
            />
          }
          label={t('processingSources')}
          loading={true}
        />
      )}
      {hasSources && (
        <>
          <Typography.Text style={{ fontSize: 16, display: 'block' }} strong>
            {t('sources')}
          </Typography.Text>
          <MessageSources
            sources={sources}
            displaySource={displaySource}
            mainDocumentId={mainDocumentId}
            publicationDocuments={publicationDocuments}
          />
        </>
      )}
    </div>
  );
};
